import styled from 'styled-components';

import Link from 'components/link';

export const Section = styled.section`
  position: relative;
  width: 100%;
  background: ${Styles.color.white};

  ${Styles.desktop`
    margin-left: auto;
    margin-right: auto;
    max-width: ${Styles.layout.sectionMaxWidth};
    width: calc(100% - 6rem);
  `}
`;

export const HomepageAlertContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${Styles.color.grey.six};
  padding: 2rem;
  border: 1px solid ${Styles.color.grey.six};
  border-left: 0;
  border-right: 0;
  margin-bottom: 0;
  margin-top: 0;

  ${Styles.desktop`
    margin-top: 6rem;
    margin-bottom: 0.2rem;
    border-radius: 10px;
  `}

  h2 {
    margin-top: 0;
    font-family: ${Styles.fontFamily.base};
    font-weight: ${Styles.fontWeight.heavy};
    color: ${Styles.color.black};
    text-transform: ${Styles.textTransform.headlines};
    margin-bottom: 1rem;
    line-height: 2rem;
  }

  p {
    color: ${Styles.color.black};
    margin: 0;
  }

  a {
    color: ${Styles.color.primary};
    margin-top: 1rem;
  }
`;

export const LinkItem = styled(Link)`
  text-decoration: none;
  color: ${Styles.color.primary};
  font-size: 1rem;
  margin-top: 15px;

  &:hover {
    cursor: pointer;
    color: ${Styles.color.primary};
    text-decoration: underline;
  }

  // Override global outline color here for contrast ratio
  :focus {
    outline-color: ${Styles.color.black};
  }
`;
